/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const volume_on_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m6 9 6.6-4.2a1.525 1.525 0 0 1 1.571-.142c.498.25.83.785.829 1.342v12c0 .557-.33 1.092-.83 1.342a1.525 1.525 0 0 1-1.57-.142L6 15m0-6H3c-.817 0-1.5.683-1.5 1.5v3c0 .817.683 1.5 1.5 1.5h3m0-6v6m15.463.75a6.658 6.658 0 0 0 0-7.1m-2.901 5.791a3.526 3.526 0 0 0 0-4.405"
    />
  </svg>
)
export default volume_on_medium
